import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { RecipeRoot } from './components/styles'
import { RecipeDetailHero } from './components/RecipeDetailHero'
import { Benefits } from './components/Benefits'
import { Ingredients } from './components/Ingredients'
import { Reviews } from '../components/Reviews/Reviews'
import { Compare } from '../components/Compare/Compare'
import { RecipeFooter } from '../components/RecipeFooter/RecipeFooter'
import { Expect } from './components/Expect'
import { Explore } from './components/Explore'
import heroChicken from '../../../../public/assets/recipes/categories/individual/hero-chicken.webp'
import heroBeef from '../../../../public/assets/recipes/categories/individual/hero-beef.webp'
import heroVenison from '../../../../public/assets/recipes/categories/individual/hero-venison.webp'
import heroDuck from '../../../../public/assets/recipes/categories/individual/hero-duck.webp'
import heroTurkey from '../../../../public/assets/recipes/categories/individual/hero-turkey.webp'
import heroLamb from '../../../../public/assets/recipes/categories/individual/hero-lamb.webp'
import chickenBadge from '../../../../public/assets/recipes/categories/individual/chicken-badge.webp'
import beefBadge from '../../../../public/assets/recipes/categories/individual/beef-badge.webp'
import duckBadge from '../../../../public/assets/recipes/categories/individual/duck-badge.webp'
import venisonBadge from '../../../../public/assets/recipes/categories/individual/venison-badge.webp'
import turkeyBadge from '../../../../public/assets/recipes/categories/individual/turkey-badge.webp'
import lambBadge from '../../../../public/assets/recipes/categories/individual/lamb-badge.webp'
import { IngredientMap } from './components/Ingredients/Ingredients'
import { Footer } from 'components/Footer'
import { ProductPageReviews } from 'fixtures/review'
import { Proteins } from 'models/Pet'

type FrozenRecipeDetailProps = {
  recipe: Proteins
}

const {
  venison,
  beefHeart,
  beefLiver,
  beefKidney,
  beefBone,
  vitamin,
  chickenHeart,
  chickenBacks,
  chickenLegs,
  chickenLiver,
  turkeyGizzards,
  turkeyTails,
  turkeyWings,
  turkeyLiver,
  lamb,
  duck,
} = IngredientMap

const {
  julie,
  cristin,
  barbara,
  autumn,
  diana,
  lori,
  nena,
  ashley,
  rachel,
  rebekah,
  seth,
  norman,
  peter,
  darlene,
  jen,
  mallia,
  jev,
  teresa,
} = ProductPageReviews

export const Recipes = {
  [Proteins.CHICKEN]: {
    heroThumb: heroChicken,
    badge: chickenBadge,
    ingredients: [chickenHeart, chickenBacks, chickenLegs, chickenLiver, vitamin],
    reviews: [julie, cristin, barbara],
  },
  [Proteins.BEEF]: {
    heroThumb: heroBeef,
    badge: beefBadge,
    ingredients: [beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [mallia, jev, teresa],
  },
  [Proteins.VENISON]: {
    heroThumb: heroVenison,
    badge: venisonBadge,
    ingredients: [venison, beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [autumn, diana, lori],
  },
  [Proteins.DUCK]: {
    heroThumb: heroDuck,
    badge: duckBadge,
    ingredients: [duck, turkeyGizzards, turkeyTails, turkeyLiver, vitamin],
    reviews: [nena, ashley, rachel],
  },
  [Proteins.TURKEY]: {
    heroThumb: heroTurkey,
    badge: turkeyBadge,
    ingredients: [turkeyTails, turkeyGizzards, turkeyWings, turkeyLiver, vitamin],
    reviews: [peter, darlene, jen],
  },
  [Proteins.LAMB]: {
    heroThumb: heroLamb,
    badge: lambBadge,
    ingredients: [lamb, beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [rebekah, seth, norman],
  },
}

export const FrozenRecipeDetail = ({ recipe }: FrozenRecipeDetailProps) => {
  const { t } = useTranslation()

  const thumbnail = Recipes[recipe].heroThumb
  const badge = Recipes[recipe].badge
  const ingredients = Recipes[recipe].ingredients
  const reviews = Recipes[recipe].reviews

  const header = <Header />

  return (
    <RecipeRoot>
      <Layout hideCTA header={header}>
        <RecipeDetailHero thumbnail={thumbnail} recipe={recipe} />
        <Benefits badge={badge} recipe={recipe} />
        <Ingredients background="accent-white" ingredients={ingredients} recipe={recipe} />
        <Explore hide={recipe} />
        <Compare background="accent-white" />
        <Reviews background="tertiary-200" reviews={reviews} icon={false} />
        <Expect />
        <RecipeFooter
          bg="tertiary-200"
          ctaLink="https://wefeedraw.gorgias.help/en-US"
          cta={t('recipes:overview.cta-4')}
          header={t('recipes:overview.contact')}
        />
        <Footer />
      </Layout>
    </RecipeRoot>
  )
}

FrozenRecipeDetail.displayName = 'FrozenRecipeDetail'
